import React from 'react';

import { Button, Text, twMerge } from 'atp-react-ui';

import FacebookIcon from '@/_shared/img/fb.svg?react';
import GoogleIcon from '@/_shared/img/google.svg?react';

export type SocialLoginType = 'google' | 'facebook';
export type SocialButtonVariantType = 'large' | 'icon';
export type SocialButtonProps = {
  type: SocialLoginType;
  variant?: SocialButtonVariantType;
  onClick: VoidFunction;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
};
type SocialButtonConfig = {
  button: {
    [type in SocialLoginType]: {
      title: string;
      Icon: React.FC;
    };
  };
  classes: {
    [variant in SocialButtonVariantType]: {
      button: string;
      icon: string;
    };
  };
};

const SOCIAL_BUTTON_CONFIG: SocialButtonConfig = {
  button: {
    google: {
      title: 'Google',
      Icon: GoogleIcon,
    },
    facebook: {
      title: 'Facebook',
      Icon: FacebookIcon,
    },
  },
  classes: {
    large: {
      button: '',
      icon: 'flex-[0.2]',
    },
    icon: {
      button: 'w-[42px] h-[42px] p-0 rounded-full',
      icon: '',
    },
  },
};

export function SocialButton({
  type,
  variant = 'large',
  onClick,
  isLoading = false,
  disabled = false,
  className,
}: SocialButtonProps) {
  const { title, Icon } = SOCIAL_BUTTON_CONFIG.button[type];
  const classes = SOCIAL_BUTTON_CONFIG.classes[variant];

  return (
    <Button
      className={twMerge('flex flex-row bg-white', classes.button, className)}
      onClick={onClick}
      showLoader={isLoading}
      disabled={disabled}
      block
      as="outline"
    >
      <div
        className={twMerge(
          'flex justify-end',
          classes.icon,
          isLoading ? 'opacity-50' : '',
          disabled ? 'grayscale' : ''
        )}
      >
        <Icon />
      </div>
      {variant === 'large' && (
        <Text as="caption-medium" className="ml-3 text-left text-accent-light">
          {title}
        </Text>
      )}
    </Button>
  );
}
